import { lazy } from 'react';
import withSuspense from 'utils/withSuspense';
const CategoryById = lazy(() => import('features/contact-form/components/CategoryById'));

const CategoryByIdRoute = withSuspense(CategoryById);

export default CategoryByIdRoute;
